module.exports = __webpack_public_path__ + "static/media/UV-w.97917278.png";